import { fetchAPI } from '@/services/prismic';
import { camelize } from '@/scripts/camelize';

import { fetchBannerContent } from './shared/banner';
import { fetchStyleCardContent } from './shared/styleCard';
import { fetchLocationContent } from './shared/location';

const getWhyCostaRicaQuery = `
query getWhyCostaRica
  {
    allWhy_costa_rica_pages {
      edges {
        node {
          meta_title 
          meta_description
          top_banner {
            ... on Top_banner {
              title
              sub_title
              background_image
            }
          }
          about_cpi {
            ... on Location {
              _meta {
                id
              }
            }
          }
          costa_rica_highlights {
            ... on Costa_rica_highlights {
              title
              highlights {
                highlight {
                  ... on Bullet {
                    title
                    name
                    description
                    logos {
                      bullet_logo
                    }
                  }
                }
              }
            }
          }
          banner {
            ... on Banner {
              _meta {
                id
              }
            }
          }
          perfect_locations {
            ... on Perfect_location {
              title
              sub_title
              locations {
                location {
                  ... on Location {
                    title
                    city
                    location_name
                    description
                    call_to_actions {
                      call_to_action {
                        ... on Call_to_action {
                          title
                          type
                          style
                          url
                          open_in_another_page
                        }
                      }
                    }
                    images {
                      image
                    }
                  }
                }
              }
            }
          }
          about_us {
            ... on Style_card {
              _meta {
                id
              }
            }
          }
          social_responsibility {
            ... on Style_card {
              _meta {
                id
              }
            }
          }
        }
      }
    }
  }
`;

export const getAlliancesBannerContentQuery = `
query getAllAlliancesBannerContent
{
  allAlliances_pages {
    edges {
      node {
        title
        sub_title
        call_to_actions {
          call_to_action {
            ...on Call_to_action {
              title
              type
              style
              url
              open_in_another_page
            }
          }
        }
      }
    }
  }
}
`


export const fetchWhyCostaRicaContent = async previewData => {
  const {
    allWhy_costa_rica_pages: {
      edges: [{
        node: whyCostaRicaContent,
      } = {}] = [],
    } = {},
  } = await fetchAPI(getWhyCostaRicaQuery, {
    previewData,
  });

  const banner = await fetchBannerContent(whyCostaRicaContent.banner._meta.id, previewData);
  const aboutUs = await fetchStyleCardContent(whyCostaRicaContent.about_us._meta.id, previewData);
  const socialResponsibility = await fetchStyleCardContent(whyCostaRicaContent.social_responsibility._meta.id, previewData);
  const aboutCpi = await fetchLocationContent(whyCostaRicaContent.about_cpi._meta.id, previewData);

  return camelize({
    ...whyCostaRicaContent,
    aboutCpi,
    banner,
    aboutUs,
    socialResponsibility,
  });
};

export const getPerfectLocationsContent = content => {
  const perfectLocations = JSON.parse(
    JSON.stringify(content.perfectLocations)
  );

  const locations = perfectLocations.locations.reduce(
    (accumulator, currentValue) => {
      const location = {
        ...currentValue.location,
        title: `${currentValue?.location?.city} ${currentValue?.location?.locationName}`,
        image: currentValue?.location?.images[0].image,
      }
      
      const card = {
        card: {
          ...location,
        },
      };

      accumulator.push(card);

      return accumulator;
    },
    []
  );
  perfectLocations.cards = [...locations];

  return perfectLocations;
}

export const fetchAlliancesBannerContent = async previewData => {
  const {
    allAlliances_pages: {
      edges: [{
        node: alliancesBannerContent, 
      } = {}] = [], 
    } = {},
  } = await fetchAPI(getAlliancesBannerContentQuery, {
    previewData,
  });

  return camelize({
    ...alliancesBannerContent,
  });
};
